import { derived, type Readable } from 'svelte/store';
import { DEFAULT_LOCALE, translate, type Vars } from './locale';
import { l10nRegistry, type SharedL10nUnit } from './l10n';

type Lookup = (key: string, vars?: Vars) => string;

/**
 * Source-locale lookup for copy fitted to a design (line counts, box widths).
 * Always resolves through `en_US`, regardless of `activeLocale`.
 * @param {string} ns - Registry namespace for this unit.
 * @param {SharedL10nUnit[]} [sharedUnits] - Additional units searched after `ns`.
 * @returns {Readable<Lookup>} Lookup store pinned to the source locale.
 */
export function createSourceL10n(ns: string, sharedUnits: SharedL10nUnit[] = []): Readable<Lookup> {
	return derived(l10nRegistry, ($registry) => {
		const sources = [$registry[ns], ...sharedUnits.map((unit) => $registry[unit.ns])];
		return (key: string, vars?: Vars): string => translate(sources, [DEFAULT_LOCALE], key, vars);
	});
}
